<template>
    <div style="display:inline-block;">

        <v-popover
            offset="16"
            :options="options"
            style="display:inline-block;"
            :open="show"
            placement="left"
        >
            <!-- This will be the popover target (for the events and position) -->
            <button class="tooltip-target b3" style="display:inline-block;" @mouseover="show = true" @mouseleave="show = false">
                <i class="fas fa-usd-circle fa-fw" />
            </button>

            <!-- This will be the content of the popover -->
            <template slot="popover">

                    <div class="line good">
                        <div class="left">Omsætning</div>
                        <div class="right good">{{ project.invoices_total ? project.invoices_total : 0 | realCurrency }}</div>
                    </div>

                    <div class="line bad">
                        <div class="left">{{ project.timelog_hours ? project.timelog_hours : 0 | realNumber }} timer</div>
                        <div class="right bad">{{ project.timelog_total ? project.timelog_total : 0 | realCurrency }}</div>
                    </div>

                    <div class="line bad">
                        <div class="left">{{ project.materials_count ? project.materials_count : 0 | realNumber }} materialer</div>
                        <div class="right bad">{{ project.materials_total ? project.materials_total : 0 | realCurrency }}</div>
                    </div>

                    <div class="divider" style="margin:10px 0;"></div>

                    <div class="line total">
                        <div class="left">Dækningsbidrag</div>
                        <div class="right" :class="{'good': project.coverage > 0, 'bad': project.coverage < 0}">{{ project.coverage ? project.coverage : 0 | realCurrency }}</div>
                    </div>

            </template>
        </v-popover>

    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .tooltip-target {
        opacity: .5;

        &:hover {
            opacity: 1;
        }
    }

    .line {
        min-width: 250px;
        display: flex;
        justify-content: space-between;
        white-space: nowrap;
        margin-bottom: $margin--small / 2;
        font-weight: 600;

        .good {
            color: $color--good;
        }

        .bad {
            color: $color--bad;
        }

        &.total {
            color: inherit;
            margin-bottom: 0;
            font-weight: 700;
        }
    }

</style>

<script>
export default {
    props: ['project'],
    data () {
        return {
            show: false,
            options: {
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip',
                    trigger: 'hover'
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// ProjectTooltip.vue?3cb0964e